import {
	Flex,
	scale,
	breakpoint,
} from "@capioweb/ui-components/src"
import styled from "styled-components"
import React from "react"
import { LifestyleForm } from "./LifestyleForm"
import { StringProperty } from "../../@types/EpiFoundationSpa/Property"
import { SharedFormProps } from "../../@types/CapioWeb/core"

interface MyPagesUserLifestyleFormBlockProps {
	requiredMessage: StringProperty
	lifestyleForm: SharedFormProps
}

const FormContainer = styled(Flex)`
	flex-direction: column;
	/* padding: ${scale.px(5)} ${scale.px(3)}; */
	max-width: ${scale.px(93)};
	margin: 0 auto;
	width: 100%;
	
	${breakpoint("m")`
		margin: 40px auto;
		border-radius: ${scale.px(3)};
		`}
`

export const MyPagesUserLifestyleFormBlock: React.FC<MyPagesUserLifestyleFormBlockProps> =
	(props) => {
		return (
			<Flex w={1} backgroundColor="greyF3" pb={4}>
				<Flex alignItems="center" flexDirection="column" w={1}>
					{/* Tabs for Manage Account and Manage Interests forms */}
					<Flex w={1} flexDirection="column" as="section" pb={4}>
						{props.lifestyleForm && (
							<FormContainer backgroundColor="white">
								<LifestyleForm lifestyleForm={props.lifestyleForm} />
							</FormContainer>
						)}
					</Flex>
				</Flex>
			</Flex>
		)
	}
